import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import { ReadMore } from '../../read-more'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_3: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-3" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/812AB8D4-4B52-4CEE-854D-F3C3D85BB221_w1920_r4.jpg'
          }
        />
        <h2>
          <span>3</span>
          Поява регулярної армії РФ
          <strong>{texts.menu_6}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          Тепер із важкої артилерії та танків обстрілюють українські міста, із
          зенітних комплексів збивають літаки, у бій вступають російські
          регулярні підрозділи. Таких бойових дій Україна ніколи до цього не
          бачила у своїй історії, тож військо і громадянське суспільство вчаться
          давати відсіч, щодня зустрічаючи нові виклики. Руйнуються житлові
          будинки, понад мільйон людей, які втекли з окупації, називають тепер
          терміном «внутрішньо-переміщені»; до фундаменту знищені аеропорти
          Донецька та Луганська, у яких тримали оборону українські військові. А
          на захоплених територіях Росія створює найжорстокішу тюрму в Європі –
          «Ізоляцію». За час війни під керівництвом Росії, що відбувалася на
          Донбасі протягом 2014-2021 років, OSINT-спільноти, аналітичні центри і
          журналісти здійснили десятки розслідувань російської військової участі
          у війні на Донбасі. Вони встановили факти артилерійських обстрілів
          українських міст з території Росії, відстежили перетин державного
          кордону російською бронетехнікою, встановили поіменні списки і
          конкретні історії російських військових, що брали участь в бойових
          діях на українській території. Проте аж до 2022 року Кремль
          заперечував участь у війні.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>5 травня</TimelineSubtitle>
          <p>
            Відбувається бій під селищем Семенівка. Він вважається першим
            серйозним зіткненням, днем, коли АТО перетворилася на війну.
            Українські підрозділи спецпризначення були атаковані під час
            облаштування блокпостів на підступах до захопленого Слов’янська,
            отримали локальну перемогу, але зазнали перших бойових втрат. Також
            від цього часу і до звільнення Слов’янська українські війська
            тримали оборону на панівній висоті – горі Карачун – де зазнавали
            ударів із різних типів зброї.
          </p>
          <TimelineVideo id={'WYVRWB-3jt4'} />

          <TimelineSubtitle>26 травня</TimelineSubtitle>
          <p>
            Російські гібридні формування здійснюють спробу штурму Донецького
            аеропорту. За кілька годин їх вибиває звідти український спецназ.
            Наступні 7 місяців аеропорт контролювали українські військові. Бій
            за ДАП став одним із найбільш виснажливих та кровопролитних за
            період війни 2014-2022 років.
          </p>

          <TimelineSubtitle>28 травня-5 червня</TimelineSubtitle>
          <p>
            У Луганську та області озброєні загони штурмують військові частини.
            Гине 22-річний український сержант, із РПГ підривають склад
            боєприпасів.
          </p>

          <TimelineSubtitle>2-4 червня</TimelineSubtitle>
          <p>
            О 4-й годині ранку 2 червня підконтрольні РФ угруповання штурмують
            Луганський прикордонний загін – останній об’єкт із українським
            прапором у Луганську. Бій тривав 17 годин. Того ж дня біля стін
            Луганської облдержадміністрації лунає вибух. Гине 8 перехожих. Росія
            звинувачує Україну у повітряному ударі, Україна свою версію подій
            досі не назвала. 3 червня штурм Луганського прикордонного загону
            поновився, наступного дня частина була взята. Усі військові об’єкти
            України у Луганську, крім аеропорту, опинилися під контролем
            російських сил.
          </p>

          <TimelineSubtitle>6 червня</TimelineSubtitle>
          <p>
            Біля Слов’янська збройні формування РФ збивають
            військово-транспортний літак ЗСУ Ан-30, гине п’ять членів екіпажу.
          </p>

          <TimelineSubtitle>14 червня</TimelineSubtitle>
          <p>
            На підльоті до Луганського аеропорту збито український
            військово-транспортний літак Іл-76, гине 40 десантників та дев’ять
            членів екіпажу.
          </p>

          <TimelineSubtitle>24 червня</TimelineSubtitle>
          <p>
            Біля гори Карачун підконтрольні Росії підрозділи збивають
            український військовий вертоліт Мі-8, гине дев’ять військових.
          </p>

          <TimelineSubtitle>5 липня</TimelineSubtitle>
          <p>
            Сили АТО звільняють Слов'янськ, Краматорськ, Дружківку та
            Костянтинівку, а наступного дня Бахмут (тоді він називався
            Артемівськ).
          </p>

          <TimelineSubtitle>11 липня</TimelineSubtitle>
          <p>
            Збройні формування РФ накривають ракетним вогнем опорний пункт
            українських підрозділів під Зеленопіллям на Луганщині. Гине 38
            солдатів і офіцерів. За даними РНБО України, обстріл вівся з
            реактивної системи залпового вогню «Торнадо-Г» – російської
            модифікації «Граду».
          </p>

          <TimelineSubtitle>14 липня</TimelineSubtitle>
          <p>
            Збивають український транспортник Ан-26 під Луганськом. Частина
            екіпажу встигла десантуватись, загинули двоє пілотів.
          </p>

          <TimelineSubtitle>19 липня-10 серпня</TimelineSubtitle>
          <p>
            95-а аеромобільна бригада ЗСУ під час рейду деблокує оточені на
            кордоні з Росією, біля Краснодона, українські підрозділи. Військові
            пройшли 470 кілометрів, 170 із яких непідконтрольною урядові
            територією, та створили коридор для виходу з оточення 3000 осіб і
            250 одиниць техніки. В операції загинули 13 військових.
          </p>

          <TimelineSubtitle>17 липня</TimelineSubtitle>
          <p>
            Під окупованим містом Сніжне Донецької області збито пасажирський
            «Боїнг-777» рейсу МН17 Амстердам-Куала Лумпур. Протягом наступних 7
            років нідерландське слідство дійде висновку, що ракета, яка поцілила
            в літак, була випущена з російського ЗРК «Бук» Курської бригади
            протиповітряної оборони. Після пострілу установку без однієї ракети
            повернули до Росії.
          </p>

          <TimelineSubtitle>липень та серпень</TimelineSubtitle>
          <p>
            Росія обстрілює територію України артилерійськими снарядами зі своєї
            території. Міжнародна рослідувальна спільнота Bellingcat підтвердила
            149 таких обстрілів. Жителі прикордонного містечка Гуково у Росії
            зняли реактивний обстріл на відео.
          </p>
          <TimelineVideo id={'IGXvZ0_BnZ0'} />

          <TimelineSubtitle>21-24 серпня</TimelineSubtitle>
          <p>
            У боях в Україні беруть участь військовослужбовці 79-ї десантної
            дивізії з Пскова та 98-ї дивізії з Іванова. Десятеро з них
            потрапляють у полон. Вони на камеру підтверджують, що командування
            направило їх на територію України воювати з українською армією.
            Десятки солдатів із цих з'єднань гинуть у боях із ЗСУ – це
            з'ясовують незалежні російські журналісти, які знаходять свіжі
            могили під Псковом.
          </p>
          <TimelineVideo id={'2c2O66E5Lz8'} />

          <TimelineSubtitle>23-29 серпня</TimelineSubtitle>
          <p>
            Після того, як сили АТО звільняють значну частину захопленої
            території та доходять до міста Іловайська, через
            українсько-російський кордон заходять регулярні частини російської
            армії. Українські підрозділи – армійські, добровольчі та МВС –
            потрапляють у котел. 28 серпня командування обох сторін домовляється
            про «зелений коридор», під час виходу ним російські війська
            розстрілюють колону. Тоді загинуло принаймні 366 українських
            військових, 158 досі вважаються зниклими безвісти, 458 були
            поранені.
          </p>

          <TimelineSubtitle>21 січня 2015</TimelineSubtitle>
          <p>
            Після 242 днів оборони остаточно захоплено Донецький аеропорт. У
            грудні під час атак окупаційні війська руйнують його старий
            термінал, на початку січня – диспетчерську вежу, в кінці січня –
            підривають новий термінал із українськими військовими всередині.
            Захищаючи Донецький аеропорт, загинули 109 українських бійців (за
            даними Генштабу), 58 з них – лише під завалами нового терміналу.
            Після цього українське командування ухвалює рішення про виведення
            сил оборони з летовища.
          </p>
          <TimelineVideo id={'Av-gV6tcCnE'} />

          <TimelineSubtitle>24 січня</TimelineSubtitle>
          <p>
            Обстріл мікрорайону Східний у Маріуполі, під час якого загинув 31
            житель міста. У травні 2018 року міжнародні розслідувачі Bellingcat
            і Служба безпеки України довели: обстріл здійснили кадрові російські
            військові. ОБСЄ підтвердила, що ракети РСЗВ Град запускали по місту
            з окупованої території.
          </p>

          <TimelineSubtitle>21 січня-18 лютого</TimelineSubtitle>
          <p>
            Відбувається бій за Дебальцеве, який завершується виходом
            українських військ з майже оточеного міста. Дебальцеве є великим
            залізничним вузлом Сходу України, а станом на початок 2015 року
            важливість міста була й у тому, що воно територіально «врізалося» в
            окуповану частину Донбасу. Ще до основного штурму підконтрольні
            Росії угруповання постійно обстрілювали Дебальцеве артилерією. А з
            підходом їх ближче до міста обстріли посилились. Україна проводила
            евакуацію цивільних
          </p>
          <TimelineVideo id={'Fx9RonqW6OA'} />

          <ReadMore>
            <p>
              Наприкінціі лютого місто, яке досі контролювала Україна, опинилося
              майже у котлі. Підрозділи ЗСУ та інші українські збройні
              формування завершили вихід із Дебальцева 18 лютого.
            </p>
            <TimelineVideo id={'UWE7x7yykR4'} />

            <p>
              Саме на тлі «Дебальцевського котла» українське керівництво у
              лютому 2015 року пішло на підписання так званих других Мінських
              угод. Саме від домовленостей, досягнутих тоді між Україною, Росією
              та західними посередниками у Мінську, сторони відштовхувались усі
              наступні 7 років війни. В рамках «Мінська» оголошувались
              періодичні, але майже ніколи не дієві перемир’я; влаштовувались
              розведення військ і облаштування пропускних пунктів з окупованою
              територією; а сам договір не раз був об’єктом критики українських
              експертів. Масштаб бойових дій після 2015 значно знизився, однак
              боєзіткнення періодично відбувалися. Російські війська
              обстрілювали наближені до лінії фронту населені пункти, жертви
              серед військових і цивільних хоч і не обчислювалися сотнями, як у
              2014-15-му, але ставалися. Наприклад, у липні 2020-го під Зайцевим
              загинув{' '}
              <a href="https://www.radiosvoboda.org/a/30741704.html">
                розвідник Ярослав Журавель
              </a>
              : Журавель був поранений під час бойового виходу, надав собі
              допомогу, але через вогонь противника його так і не змогла забрати
              евакуаційна група. Цей випадок набув розголосу, адже пораненого
              кілька днів бачили з українського БПЛА.
            </p>

            <p>
              Режим війни низької інтенсивності, як називали його військові
              аналітики, тривав до січня 2022 року, коли Росія пішла в нову
              атаку: й уже не лише на Донбасі, а на півночі та півдні України.
            </p>
          </ReadMore>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
